var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"floating-whatsapp",attrs:{"id":"floating-whatsapp"},on:{"click":_vm.chatOnWhatsApp}},[_c('font-awesome-icon',{attrs:{"icon":['fab', 'whatsapp']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }